module.exports = __webpack_public_path__ + "img/Books-low.f3dd5b6d.jpg";